import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getBeefTrendsBackend(params) {
  return request({
    url: '/GetBeefTrendsBackend',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1000000001,
      MessageID: btcguid(),
      Data: {
        Type: params.Type,
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Keywords: params.Keywords
      }
    }
  })
}

export function updateBeefTrend(params) {
  return request({
    url: '/UpdateBeefTrend',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1000000002,
      MessageID: btcguid(),
      Data: {
        Type: params.Type,
        Logo: params.Logo,
        Name: params.Name,
        NameEn: params.NameEn,
        TypeLogo: params.TypeLogo,
        BeefTrendID: params.BeefTrendID
      }
    }
  })
}

export function uploadTrendLogo(params) {
  const formData = new FormData()
  formData.append('MessageType', 1000000003)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/UploadTrendLogo',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}



// WEBPACK FOOTER //
// ./src/api/trend.js